import isEmpty from 'lodash/isEmpty'

export default function (date: string | Date): Date | string {
  if (isEmpty(date)) return 'N/A'
  return new Date(date).toLocaleString('en-us', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
